import { createContext, useState } from "react";
import apiClientDefault from '../utils/apiClient';

export const OrderContext = createContext()

// Shared api client (withCredentials + CSRF interceptor)
const apiClient = apiClientDefault;

const OrderContextProvider =(props)=>{

    const [orderDetails, setOrderDetails] = useState({ orderNumber: '', email: '' });
    const [uuid, setUuid] = useState();
    const [claimType, setClaimType] = useState()
    const [claimId, setClaimId] = useState()

    
    const [orderProduct, setOrderProduct] = useState()
    const [refundProduct, setRefundProduct] = useState()
    const [refundShipment, setRefundShipment] = useState()

    let refund_process = sessionStorage.getItem('refundProcess')
    const [process, setProcess] = useState(JSON.parse(refund_process))

    let invoice_process = sessionStorage.getItem('invoiceProcess')
    const [invoiceProcess, setInvoiceProcess] = useState(JSON.parse(invoice_process))

    let missing_process = sessionStorage.getItem('missingProcess')
    const [missingProcess, setMissingProcess] = useState(JSON.parse(missing_process))

    let missing_products=  sessionStorage.getItem('missingProducts')
    const [missingProduct, setMissingProduct] = useState(JSON.parse(missing_products))

    // let claims_sessions=  sessionStorage.getItem('refundProduct')
    // const [refundProduct, setRefundProduct] = useState(JSON.parse(claims_sessions))

    let shipping_adress=  sessionStorage.getItem('shippingAdress')
    const [shippingAdress, setShippingAdress] = useState(JSON.parse(shipping_adress))

    

    let order_number = sessionStorage.getItem('orderNumber')  
    let email_initial = sessionStorage.getItem('email')
    const [orderNumber, setOrderNumber] = useState(order_number);
    const [email, setEmail] = useState(email_initial);




    let value = {
        setUuid,
        uuid,
        claimType,
        setClaimType,
        setRefundProduct,
        refundProduct,
        setOrderProduct,
        orderProduct,
        setProcess,
        process,
        setOrderNumber,
        orderNumber,
        setEmail,
        email,
        setClaimId,
        claimId,
        setInvoiceProcess,
        invoiceProcess,
        missingProcess, 
        setMissingProcess,
        missingProduct, 
        setMissingProduct,
        shippingAdress, 
        setShippingAdress,
        refundShipment, 
        setRefundShipment,
        apiClient // Diğer hook'lar için axios instance
    }


    return(
        <OrderContext.Provider value={value}>
             {props.children}
        </OrderContext.Provider>
    )

}

export default OrderContextProvider
